import { combineReducers } from "redux";

import { appConfigReducer } from "./reducers/appConfigReducers";
import { entityOrganizationReducer } from "./reducers/enittyPortalReducer";
import { loginReducer } from "./reducers/loginReducer";
import { lookupReducer } from "./reducers/lookupReducers";
import { loaderReducer } from "./reducers/loaderReducer";
import { groupReportReducer } from "./reducers/groupReportReducer";
import { ballotReportReducer } from "./reducers/ballotReportsReducer";
import { signOutReducer } from "./reducers/signOutReducer";

const rootReducer = combineReducers({
  appConfig: appConfigReducer,
  entityData: entityOrganizationReducer,
  lookup: lookupReducer,
  logins: loginReducer,
  groupReport: groupReportReducer,
  ballotReport: ballotReportReducer,
  loadingData: loaderReducer,
  signOutData: signOutReducer,
});

export default rootReducer;
